var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "managerList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.manager.plural")))]
                  ),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("entities.manager.singular")) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  class: { show: true, "show-mobile": _vm.isMobile },
                  attrs: {
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "Id" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.id) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Name" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.name) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "LastName" } }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.model.lastName) + "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Email" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.email) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Phone" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.phone) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Clubs" } },
                    [
                      _vm._l(_vm.model.clubs, function(club) {
                        return _c("div", { key: club.id }, [
                          _vm._v(
                            "\n          " + _vm._s(club.name) + "\n        "
                          )
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Created at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.created)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Updated at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.modified)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _vm.hasRoleToUpdate
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.edit")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToReadLogs
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-history",
                                type: "infor"
                              },
                              on: {
                                click: function($event) {
                                  _vm.history()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.history")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToDelete
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.delete")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f15dbb3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f15dbb3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/manager/manager-show.vue
// module id = null
// module chunks = 